// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"48":"braintree-dropin","387":"braintree-core"}[chunkId] + ".js";
};